import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { useTranslation } from '@mint-lib/i18n';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

import type { SelectRendererType } from '../../../types/grid.types.js';
import { getFormattedValue } from '../../../utils/getFormattedValue.jsx';

export const SelectRenderer = (
  props: CustomCellRendererProps<MediaPlan.MediaData, string | string[]> &
    SelectRendererType,
) => {
  const { t } = useTranslation('@myn/planning_v2');

  const formatterFn = () => {
    const enabledPairs = props.options?.map(
      (option) => [option.value, option.label] as const,
    );

    const disabledPairs = props.disabledOptions?.map(
      (option) => [option.value, option.label] as const,
    );

    const optionsMap = new Map([
      ...(enabledPairs ?? []),
      ...(disabledPairs ?? []),
    ]);

    if (Array.isArray(props.value)) {
      const labels = props.value.map((value) => optionsMap.get(value));
      return labels.join(', ');
    }

    const label = optionsMap.get(props.value ?? '');

    return label;
  };

  const formattedValue = getFormattedValue(props, {
    formatterFn,
    placeholderText: t('Select'),
  });

  return formattedValue;
};
